import React, {createContext} from "react";
import VisitorHistory from "./visit/history";
import VisitorInout from "./visit/inout";
import BlackList from "./visit/blacklist";
import Certificate from "./visit/certificate";
import Business from "./visit/business";
import Normal from "./visitor-application/normal";
import Long from "./visitor-application/long";
import Position from "./site/position";
import Ci from "./site/ci";
import Promotion from "./site/promotion";
import Policy from "./site/policy";
import VisitorApprove from "./visit/approve";
import Notice from "./contents/notice";
import Faq from "./contents/faq";
import Terms from "./contents/terms";
import Education from './contents/education';
import My from "./system/my";
import StaffManage from "./staff/manage";
import {Gallery} from "./contents/gallery";
import VisitorDashBoard from "./visit/dashboard";
import Unreturned from "./visit/unreturned";

export function reducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return {
                hostInfo: action.hostInfo,
                auth : AccessAuth(action.hostInfo)
            };
        case 'LOGOUT':
            localStorage.clear();
            return null;
        default:    // get
            return state;
    }
}

function AccessAuth(hostInfo) {
    switch (hostInfo.authLevel) {
        case '사이트관리자' :
            return MASTER;
        case '임직원' :
            return DEFAULT;
        case '보안실' :
            return INFO;
    }
}

const INFO = {
    access : {
        urls : [
            { name : '방문관리', url : '/admin/visitor-list' },
        ],
        'VisitorManage' : {
            labels : ["방문 입출문" , "방문 이력", "방문 제한 관리", "협력업체 관리", "미반납 관리"],
            components : [<VisitorInout/>, <VisitorHistory/>, <BlackList/>, <Business/>, <Unreturned/>]
        }
    }
}
const DEFAULT = {
    access : {
        urls : [
            { name : '방문관리', url : '/admin/visitor-list' },
            { name : '방문신청', url : '/admin/visitor-application' },
            { name : '시스템관리', url : '/admin/system-manage' }
        ],
        'VisitorManage' : {
            labels : ["방문 승인" , "방문 이력", "방문 제한 관리"],
            components : [<VisitorApprove/>, <VisitorHistory/>, <BlackList/>]
        },
        'VisitorApplication' : {
            labels : ["일반 신청", "장기 신청"],
            components : [<Normal/>, <Long/>]
        },
        'System' : {
            labels : ["내 계정"],
            components : [<My/>]
        }
    }
}
const MASTER = {
    access : {
        urls: [
            {name: '방문관리', url: '/admin/visitor-list',},
            {name: '방문신청', url: '/admin/visitor-application'},
            {name: '임직원관리', url: '/admin/staff-manage'},
            {name: '사이트관리', url: '/admin/site-manage'},
            {name: '컨텐츠관리', url: '/admin/contents-manage'},
            {name: '시스템관리', url: '/admin/system-manage'}
        ],
        'VisitorManage': {
            labels: ["방문 현황", "방문 승인", "방문 입출문", "방문 이력", "방문 제한 관리", "유해화학물질", "미반납 관리"],
            components: [
                <VisitorDashBoard/>,
                <VisitorApprove/>,
                <VisitorInout/>,
                <VisitorHistory/>,
                <BlackList/>,
                <Certificate/>,
                <Unreturned />
            ]
        },
        'VisitorApplication': {
            labels: ["일반 신청", "장기 신청"],
            components: [<Normal/>, <Long/>]
        },
        'System': {
            labels: ["내 계정"],
            components: [<My/>]
        },
        'Site': {
            labels: ["방문위치 설정", "CI 설정",  "미디어 관리"],
            components: [<Position/>, <Ci/>,  <Gallery/>]
        },
        'Contents': {
            labels: ["공지사항", "FAQ", "서약서 관리", "교육 관리"],
            components: [<Notice/>, <Faq/>, <Terms/>, <Education/>]
        },
        'Staff': {
            labels: ["임직원관리"],
            components: [<StaffManage/>]
        }
    }
}